{
  "SEARCH": {
    "TABS": {
      "ALL": "TODOS",
      "CONTACTS": "Contactos",
      "CONVERSATIONS": "Conversas",
      "MESSAGES": "Mensagens"
    },
    "SECTION": {
      "CONTACTS": "Contactos",
      "CONVERSATIONS": "Conversas",
      "MESSAGES": "Mensagens"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "A pesquisar",
    "LOADING_DATA": "A carregar",
    "EMPTY_STATE": "Não foi encontrado {item} para a consulta '{query}'",
    "EMPTY_STATE_FULL": "Nenhum resultado encontrado para a consulta '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ para focar",
    "INPUT_PLACEHOLDER": "Digite 3 ou mais caracteres para pesquisar",
    "RECENT_MESSAGES": "As minhas mensagens enviadas recentemente",
    "EMPTY_STATE_DEFAULT": "Procurar por ID da conversa, email, número de telefone, mensagens para obter melhores resultados. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Ler mais",
    "WROTE": "escreveu:",
    "FROM": "de",
    "EMAIL": "e-mail",
    "EMAIL_SUBJECT": "assunto"
  }
}
